import { Info } from 'luxon'
import React, { FunctionComponent, useCallback, useMemo } from 'react'

import { Box, Flex, Typo } from '../atoms'
import { MonthsRange } from '../validators'
import { SelectInput } from './SelectInput'

export interface MonthsRangeInputProps {
  'aria-labelledby'?: string
  name: string
  to: string | null
  value: MonthsRange | undefined
  placeholders: {
    from: string
    to: string
  }
  onChange: (value: MonthsRange) => void
}

export const MonthsRangeInput: FunctionComponent<MonthsRangeInputProps> = ({
  'aria-labelledby': ariaLabelledBy,
  name,
  to,
  value,
  onChange,
  placeholders,
}) => {
  const range = value ?? { from: undefined, to: undefined }

  const onFromChange = useCallback(
    (from: number | undefined) => onChange({ ...range, from }),
    [onChange, range],
  )

  const onToChange = useCallback(
    (to: number | undefined) => onChange({ ...range, to }),
    [onChange, range],
  )

  const months = useMemo(
    () =>
      Info.months().map((it, index) => ({
        value: index + 1,
        text: it,
      })),
    [],
  )

  return (
    <Box>
      <Flex width={1} justifyContent='flex-start' gap={3}>
        <Box width='240px'>
          <SelectInput<number>
            aria-labelledby={ariaLabelledBy}
            name={`${name}-from`}
            values={months}
            value={range?.from}
            placeholder={placeholders.from}
            onChange={onFromChange}
          />
        </Box>
        {to && <Typo as='span'>{to}</Typo>}
        <Box width='240px'>
          <SelectInput<number>
            aria-labelledby={ariaLabelledBy}
            name={`${name}-to`}
            values={months}
            value={range?.to}
            placeholder={placeholders.to}
            onChange={onToChange}
          />
        </Box>
      </Flex>
    </Box>
  )
}
